import {
  type FeatureExpansionRequestType,
  FeatureExpansionRequestTypes,
} from '@webapp/core/services/Marketo'
import {
  type DiscoverMorePageTab,
  DiscoverMorePageTabs,
} from '@webapp/platform/discover-more/pages'

// Canonical per-tab value shared by the FullStory `feature` property and the
// Marketo `context` field, so leads reconcile. Partial: the What's new tab has
// no feature to request a demo for — its `feature` value lives with its own
// feature slice.
export const DISCOVER_MORE_FEATURE: Partial<
  Record<DiscoverMorePageTab, FeatureExpansionRequestType>
> = {
  [DiscoverMorePageTabs.GUIDED_INTAKE]:
    FeatureExpansionRequestTypes.GUIDED_INTAKE,
  [DiscoverMorePageTabs.AP]: FeatureExpansionRequestTypes.AP,
  [DiscoverMorePageTabs.CONTRACTS]: FeatureExpansionRequestTypes.CONTRACTS,
  [DiscoverMorePageTabs.CUSTOM_FIELDS]:
    FeatureExpansionRequestTypes.CUSTOM_FIELDS,
}
